// extracted by mini-css-extract-plugin
module.exports = {"infos":"ArtistIndexOverviewInfo-infos-2yDGn"};